var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyvideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "miei_video",
    "data-name": "miei video",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 48,
    viewBox: "0 0 55 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_42",
    "data-name": "Rettangolo 42",
    width: 55,
    height: 48,
    fill: "#f2f5ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Profile",
    "data-name": "Iconly/Bold/Profile",
    transform: "translate(16 12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_31",
    "data-name": "Tracciato 31",
    d: "M8,13.174c4.339,0,8,.705,8,3.425S12.315,20,8,20c-4.338,0-8-.705-8-3.425S3.685,13.174,8,13.174ZM8,0A5.292,5.292,0,1,1,2.706,5.291,5.273,5.273,0,0,1,8,0Z",
    fill: "#8b9cce"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyvideo);
export default __webpack_public_path__ + "static/media/myvideo.b0ec2b8e3d43926e722d2027e056341f.svg";
export { ForwardRef as ReactComponent };